import { EOrganization, ERef } from 'lib/types';
import { useFirestoreQueryListener } from 'lib/frontend/hooks/useFirestoreQueryListener';
import { getFirebaseContext } from 'utils/firebase';
import { ModularSizeService } from 'lib/services/modularSizeService';

export function usePublisherModularSizes(
  publisherRef?: ERef<EOrganization> | null
) {
  const modularSizeService = new ModularSizeService(
    getFirebaseContext().modularSizesRef()
  );

  const { ownedModularSizesQuery, allowedModularSizesQuery } = publisherRef
    ? modularSizeService.getPublisherOrgModularSizesQueries(publisherRef)
    : {
        ownedModularSizesQuery: undefined,
        allowedModularSizesQuery: undefined
      };

  const ownedModularSizes = useFirestoreQueryListener(
    ownedModularSizesQuery,
    [publisherRef?.id],
    {
      message: 'Error listening to owned modular sizes query snapshot',
      tags: {
        publisherOrganizationId: publisherRef?.id || ''
      }
    }
  );

  const allowedModularSizes = useFirestoreQueryListener(
    allowedModularSizesQuery,
    [publisherRef?.id],
    {
      message: 'Error listening to allowed modular sizes query snapshot',
      tags: {
        publisherOrganizationId: publisherRef?.id || ''
      }
    }
  );

  const allModularSizes = [
    ...(ownedModularSizes?.docs ?? []),
    ...(allowedModularSizes?.docs ?? [])
  ];

  const deduplicatedModularSizes =
    modularSizeService.deduplicateModularSizes(allModularSizes);

  const loading = ownedModularSizes === null || allowedModularSizes === null;

  return { loading, modularSizes: deduplicatedModularSizes };
}
